/*
 * Add Class on focus
 */
(function ($) {
  function AddFocusClass(options) {
    this.options = $.extend({
      container: null,
      element: ':input',
      focusClass: 'focus',
      stayFocusOnFilled: false,
    }, options);
    this.initStructure();
    this.attachEvents();
  }
  AddFocusClass.prototype = {
    initStructure() {
      this.container = $(this.options.container);
      this.element = this.container.find(this.options.element);
    },
    attachEvents() {
      const self = this;
      this.focusHandler = function () {
        self.container.addClass(self.options.focusClass);
      };
      this.blurHandler = function () {
        if (self.options.stayFocusOnFilled) {
          self.container.toggleClass(self.options.focusClass, !!self.element.val().trim().length);
        } else {
          self.container.removeClass(self.options.focusClass);
        }
      };
      this.blurHandler();
      this.element.on({
        focus: this.focusHandler,
        blur: this.blurHandler,
      });
    },
    destroy() {
      this.container.removeClass(this.options.focusClass);
      this.element.off({
        focus: this.focusHandler,
        blur: this.blurHandler,
      });
    },
  };

  $.fn.addFocusClass = function (options) {
    return this.each(function () {
      const params = $.extend({}, options, {
        container: this,
      });
      const instance = new AddFocusClass(params);
      $.data(this, 'AddFocusClass', instance);
    });
  };
}(jQuery));
